import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import apiCall from '../../apiCall.js';

import { UPLOAD_CONFIG_EXCEL, UPLOAD_CONFIG_EXCEL_SUCCESS, UPLOAD_CONFIG_EXCEL_ERROR } from './../../actionType.js';

function* uploadConfigExcel({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/upload-file-gm`,
      method: 'POST',
      data: payload?.data,
      isFormData: true,
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
    });

    if (response?.status === 200) {
      cogoToast.success('File uploaded successfully');
      yield put({
        type: UPLOAD_CONFIG_EXCEL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({ type: UPLOAD_CONFIG_EXCEL_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: UPLOAD_CONFIG_EXCEL_ERROR, payload: error });
  }
}

export function* watchUploadConfigExcel() {
  yield takeEvery(UPLOAD_CONFIG_EXCEL, uploadConfigExcel);
}

function* uploadConfigExcelSaga() {
  yield all([fork(watchUploadConfigExcel)]);
}

export default uploadConfigExcelSaga;
